import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";


/** @deprecated En desuso desde v1.3.0 */
export function _SvAdmin_GetVersionConfig(version: string): Promise<DataDRequest.IResultadoPeticion<null /*KIDI_INITIAL_CONFIG*/>> {
    /* const url = Global._GLOBAL_CONF.IncApp_WebUrlOrigin + "GetSettings";
    const params = {
        v: (version || Global._APP_VERSION_BASE)
    }; */
    return new Promise(resolve => {
        resolve(null)
        /* DataDRequest._Request(url, "GET", params, (res: KIDI_INITIAL_CONFIG) => {
            resolve({
                Resultado: res ? 1 : -1,
                Data: res
            })
        }) */
    })
}


export interface IExportarExcelPlantillaInfo {
    Escuela: "C6",
    FechaDescrga: "C7",
    RangoTable: ["B9", "B11"],
    Titulo: "C2",
    Pie: "B13"
}

// interface IExportarExcelParams {
//     IdEscuela: number[],
//     IdCategoria: number
// }
export interface IExportarExcelResponse {
    Info: IExportarExcelPlantillaInfo;
    FileTemplate: File;
    EscuelaLogos: Map<number, File> | null;
}

//----------------------------------------------Archivos
export async function _SvAdmin_GetExcelTemplateToExport(
    idsEscuelas: number[],
    idCategoria: number,
    requestType: Entidad.CTipoRequest
): Promise<DataDRequest.IRequestResponseA<IExportarExcelResponse>> {

    const url = _APP_CONFIG.URL_SrvRoot + "archivo/exportar/plantilla/ObtenerExcel";
    const params = {
        "IdEscuela": idsEscuelas?.toString() || "0",
        "IdCategoria": idCategoria
    }

    return DataDRequest._RequestFormData(url, "GET", params)
        .then<DataDRequest.IRequestResponseA<IExportarExcelResponse>>((result) => {
            const hasData = Boolean(result?.has("info") && result?.has("plantilla"));
            let logos: Map<number, File> = null;;

            if (hasData) {
                logos = new Map();
                idsEscuelas.forEach(idEscuela => {
                    if (result.has("logo" + idEscuela)) {
                        logos.set(idEscuela, result.get("logo" + idEscuela) as File);
                    }
                })
            }

            return ({
                Resultado: hasData ? 1 : DataDRequest.__RESCODE_UNKNOWNERROR,
                Datos: {
                    Info: hasData ? JSON.parse(result.get("info").toString()) : null,
                    FileTemplate: (result?.get("plantilla") as File || null),
                    EscuelaLogos: logos
                },
                TipoRequest: requestType
            })
        })
        .catch(() => ({
            Resultado: DataDRequest.__RESCODE_UNKNOWNERROR
        }))
}
